import { combineReducers } from "@reduxjs/toolkit";
import topnavSlice from "./slices/topnav.slice";
import homeSlice from "./slices/home.slice";
import summarySlice from "./slices/summary.slice";
import transactionSlice from "./slices/transaction.slice";
import overviewSlice from "./slices/overview.slice";
import irregularitiesSlice from "./slices/irregularities.slice";
import upiTxnAnalysisSlice from "./slices/upiTxnAnalysis.slice";
import cashflowAnalysisSlice from "./slices/cashflowAnalysis.slice";
import amlAnalysisSlice from "./slices/amlAnalysis.slice";
import bouncedchequesSlice from "./slices/bouncedcheques.slice"
import createReportSlice from "./slices/createReport.slice";
import extractedDataSlice from "./slices/extractedData.slice";
import categoriesSlice from "./slices/categories.slice"
import monthlySummarySlice from "./slices/monthlySummary.slice";
import reportDetailsSlice from "./slices/reportDetails.slice";
import counterpartySlice from "./slices/counterparty.slice"
import userSlice from "./slices/user.slice";
import notificationSlice from "./slices/notification.slice";
import updateReportSlice from "./slices/updateReport.slice";
import availableBalanceSlice from "./slices/availableBalance.slice";

const reducers = combineReducers({
    user: userSlice,
    topnav: topnavSlice,
    home: homeSlice,
    summary: summarySlice,
    transaction: transactionSlice,
    overview: overviewSlice,
    irregularities: irregularitiesSlice,
    upiTxnAnalysis: upiTxnAnalysisSlice,
    cashflowAnalysis: cashflowAnalysisSlice,
    amlAnalysis: amlAnalysisSlice,
    availableBalance: availableBalanceSlice,
    bouncedcheques: bouncedchequesSlice,
    createReport: createReportSlice,
    extractedData: extractedDataSlice,
    categories: categoriesSlice,
    monthlySummary: monthlySummarySlice,
    reportDetails: reportDetailsSlice,
    counterparty: counterpartySlice,
    notification: notificationSlice,
    updateReport: updateReportSlice
});

const rootReducer = (state, action) => {
    if (action.type === 'auth/logout') {
        state = undefined; 
    }
    return reducers(state, action);
};

export default rootReducer;